import { Component } from '@angular/core';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html'
})
export class SignoutComponent { }

// Keep this class here to prevent console errors
